import { useAtomValue } from 'jotai';
import { rsimFiltersAtom, rsimSortingAtomWithStorage } from 'atoms/filters/rsim-products';
import { useExternalRowSelectionClearOnFiltersChange } from 'src/common/components/ConfigurableTable/Components/Rows/ExternalRowSelection/hooks/useExternalRowSelectionClearOnFiltersChange';

export const RSimProductsSelectionReset = () => {
  const filters = useAtomValue(rsimFiltersAtom);
  const sorting = useAtomValue(rsimSortingAtomWithStorage);

  useExternalRowSelectionClearOnFiltersChange({ filters, sorting });

  return null;
};
